
import Vue from 'vue'
import JcdcCard from '@/components/jcdc/JcdcCard.vue'
import JcdcLoginTemplate from '@/components/jcdc/JcdcLoginTemplate.vue'

export default Vue.extend({
  name: 'JcdcErrorAccessDenied',
  components: {
    JcdcCard,
    JcdcLoginTemplate,
  },
  props: {
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    errorMessage: { type: String, default: '' },
  },
  data() {
    return {
      logoutTimer: 0,
    }
  },
  mounted() {
    this.logoutTimer = window.setTimeout(this.logout, 10 * 1000) // 10 seconds
  },
  methods: {
    logout() {
      this.$emit('logout')
      clearTimeout(this.logoutTimer)
    },
  },
})
